import { useEffect } from 'react';
import { useRouter } from 'next/router';

const usePageViewTracking = () => {
    const router = useRouter();
    useEffect(() => {
        const handleRouteChange = url => {
            window.dataLayer?.push({
                event: 'page_view',
                page: url
            });
        };

        router.events.on('routeChangeComplete', handleRouteChange);
        return () => {
            router.events.off('routeChangeComplete', handleRouteChange);
        };
    }, [router.events]);
};

export default usePageViewTracking;
